import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

const FullHeightFlexPage = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      {children}
    </Box>
  );
};

export default FullHeightFlexPage;
